import { MapPin, ExternalLink } from 'lucide-react';
import { PARTNER_LOGIN_PATH } from '../salon-admin/utils/loginPaths';
import './FranchiseStoreLocationRequiredModal.css';

/**
 * Shown when kiosk login succeeds but the franchise has not set store GPS yet.
 */
export default function FranchiseStoreLocationRequiredModal({
  open,
  franchiseName = '',
  onClose,
}) {
  if (!open) return null;

  const partnerUrl =
    typeof window !== 'undefined'
      ? `${window.location.origin}${PARTNER_LOGIN_PATH}`
      : PARTNER_LOGIN_PATH;

  return (
    <div className="ff-loc-modal" role="dialog" aria-modal="true" aria-labelledby="ff-loc-title">
      <div className="ff-loc-modal__backdrop" onClick={onClose} />
      <div className="ff-loc-modal__card">
        <div className="ff-loc-modal__icon" aria-hidden>
          <MapPin size={28} />
        </div>
        <h2 id="ff-loc-title" className="ff-loc-modal__title">
          Set store location first
        </h2>
        <p className="ff-loc-modal__body">
          {franchiseName ? (
            <>
              <strong>{franchiseName}</strong> does not have a registered GPS pin yet.
            </>
          ) : (
            <>This franchise does not have a registered GPS pin yet.</>
          )}{' '}
          Face Identity and Salon device login only work after the store location is captured
          for HQ analytics maps. Geofence limits apply only when enabled in Workspace.
        </p>
        <ol className="ff-loc-modal__steps">
          <li>Sign in to the Partner dashboard</li>
          <li>Open <strong>Store location</strong> in the sidebar</li>
          <li>Stand at the store and capture / save the pin</li>
          <li>Return here and sign in again</li>
        </ol>
        <div className="ff-loc-modal__actions">
          <a
            className="ff-loc-modal__primary"
            href={partnerUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open Partner login
            <ExternalLink size={16} />
          </a>
          <button type="button" className="ff-loc-modal__secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
